export default "<article class=\"page-detail\">\n  <h1>Sorry this page could not be found</h1>\n</article>\n"